import React, { useEffect, useState } from "react";
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

const PatientAllergies = ({patientData}) => {
  const [allergies, setAllergies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const params = useParams();
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();

  const uuid =
    LoginUserType === "Patient" ? LoginUserDetails?.uuid : patientData?.uuid;

  const navigatePatientAllergies = () => {
    LoginUserType === "Patient"
      ? navigate("/patient/allergies")
      : navigate(`/provider/patient/allergies/${uuid}`);
  };

  useEffect(() => {
    if (!uuid) return;

    const apiUrl =
      LoginUserType === "Patient"
        ? `/apis/default/portal/patient/${uuid}/allergy`
        : `/apis/default/api/patient/${uuid}/allergy`;

    ApiServices.get(apiUrl, {
      Authorization: `Bearer ${accessToken}`,
    })
      .then((response) => {
        if (response.data.data?.length) {
          // Sort by modifydate (latest first) and take the first 3 allergies
          const sortedAllergies = response.data.data
            .sort((a, b) => new Date(b.modifydate) - new Date(a.modifydate))
            .slice(0, 3);
          setAllergies(sortedAllergies);
        } else {
          setAllergies([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching allergies:", error);
        setAllergies([]);
      })
      .finally(() => setLoading(false));
  }, [uuid, LoginUserType, accessToken]);

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391" }}>
        Allergies
      </Typography>
      <Card
        sx={{
          height: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          border: "2px solid #028391",
          borderRadius: "12px",
          minHeight:"230px"
        }}
      >
        <CardContent>
          {loading ? (
            <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
              Loading allergies...
            </Typography>
          ) : allergies.length > 0 ? (
            allergies.map((allergy, index) => (
              <>
              <Box
                                              key={index}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                mt: 1,
                                                p: 1,
                                                borderRadius: "8px",
                                                backgroundColor: "#f5f5f5",
                                              }}
                                            >
                                              {/* File Name */}
                                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Typography variant="body2">{allergy.title  || "Unknown Report"}</Typography>
                                              </Box>
                              
                                              {/* Document Date */}
                                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Typography variant="body2">{allergy.subtype || "No Date"}</Typography>
                                              </Box>
                                            </Box>

              </>
            ))
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
              <ErrorOutline sx={{ fontSize: 40, color: "gray" }} />
              <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
                No allergies recorded.
              </Typography>
            </Box>
          )}

          <Button
            sx={{
              mt: 2,
              color: "#028391",
              textTransform: "none",
              "&:hover": { backgroundColor: "#02839120" },
            }}
            onClick={navigatePatientAllergies}
          >
            Please update your allergy details if available.
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatientAllergies;
